<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__company}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="名称：">
          <el-input
            v-model="dataForm.name"
            placeholder="名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:company:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="createStorages()"
            >批量创建仓库</el-button
          >
        </el-form-item> -->
        <el-form-item>
          <el-button type="danger" @click="showUploadDialog()">导入</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="category"
          label="类型"
          header-align="center"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="province"
          label="省份"
          header-align="center"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          header-align="center"
          width="300"
        ></el-table-column>
        <el-table-column label="开票信息" header-align="center" align="center" >
          <template slot-scope="scope">
            <div
              class="flex"
              v-for="item in scope.row.receiptList"
              :key="item.id"
            >
              <div style="width:300px;text-align: left;">开户行：{{ item.accountName }}</div>
              <div style="width:260px;margin-left:20px;text-align: left;">银行账号：{{ item.taxCode }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.contact1 }}</div>
            <div>{{ scope.row.contact2 }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.remark" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('trade:company:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="$hasPermission('trade:company:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
        :categoryKey="categoryKey"
      ></add-or-update>
    </div>
    <common-upload
      ref="uploader"
      @success="getDataList"
      uploadUrl="/trade/company/import"
      placeHolder=""
      title="供应商导入"
    ></common-upload>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./add-or-update";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/company/page",
        getDataListIsPage: true,
        exportURL: "/trade/company/export",
        deleteURL: "/trade/company",
        deleteIsBatch: true,
      },
      dataForm: {
        name: "",
      },
    };
  },
  methods: {
    createStorages() {
      const loading = this.$loading();
      this.$http
        .post(`/trade/company/create/storage`, this.dataListSelections)
        .then(({ data: res }) => {
          loading.close();
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.$message.success("操作成功");
        })
        .catch((e) => {
          loading.close();
          console.log(e);
        });
    },
    beforeTableBinding(dataList) {
      dataList.forEach((row) => {
        if (row.remark) {
          row.remark = JSON.parse(row.remark);
        }
      });
    },
    showUploadDialog() {
      this.$refs.uploader.init();
    },
  },
  components: {
    AddOrUpdate
  },
};
</script>
